module.exports = __webpack_public_path__ + "img/benefit-new-member.0f917fd0.png";